//this set the external filters for the invoices
import { useLocalStorage } from 'react-use'
import { StorageKeys } from '../../../config/StorageKeys'
import { StatusFilterOptions } from '../list/filters/StatusFilterOptions'
import find from 'lodash/find'
import { useUser } from '@ztechapps/common.hook'
import { formatConstants, formatDate, toDate } from '@ztechapps/common.utils'

export const useInvoiceFilters = () => {
  const statusFilter = useLocalStorage(StorageKeys.invoiceStatusFilter, find(StatusFilterOptions, { name: 'All' }))
  const { user } = useUser()

  const timeZone = user?.timeZone || 'America/Chicago'
  const defaultDate = formatDate(toDate(), formatConstants.isoDate, timeZone)
  const issueDateYearMonthFilter = useLocalStorage(StorageKeys.invoiceIssuePeriodFilter, defaultDate)

  //build the filters for invoices
  let filter: {
    status?: Record<any, any>
    issueDateYearMonth?: string
  } = {}

  //build the filter for the issueDateYearMonth
  const [issueDateYearMonth] = issueDateYearMonthFilter
  const storedDate = toDate(issueDateYearMonth, timeZone)
  if (storedDate.isValid()) {
    filter = { issueDateYearMonth: storedDate.format('YYYY-MM') }
  }

  //build the filter for the status
  const [status] = statusFilter
  filter = { ...filter, ...status.filter }

  return {
    statusFilter,
    issueDateYearMonthFilter,
    filter,
  }
}
